import { Controller } from "@hotwired/stimulus"
import ahoy from 'ahoy.js'

export default class extends Controller {
  static targets = ["items"]

  toggle(event){
    const hidden = this.itemsTarget.classList.contains("hidden")

    ahoy.track('$click', { name: 'menu', action: hidden ? 'show' : 'hide' })

    this.itemsTarget.classList.toggle("hidden")
    this.itemsTarget.parentNode.classList.toggle("z-50")
    this.itemsTarget.parentNode.classList.toggle("z-[5]")
    this.itemsTarget.parentNode.classList.toggle("inline")
    this.itemsTarget.parentNode.classList.toggle("w-full")
    this.itemsTarget.parentNode.classList.toggle("lg:w-2/5")
    this.itemsTarget.parentNode.classList.toggle("bg-neutral-950/75")
  }
}

